import { ArrowBack } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import BestOffersTable from "components/BestOffersTable";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "scenes/navbar";
import apiService from "services/apiService";

// url /run/runId
const OfferPage = () => {
  const runId = useParams().id;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data, error } = await apiService.fetchData(
          `/rent/offers/run/${runId}`
        );

        if (!error) {
          setData(data);
          setLoading(false);
        } else if (error) {
          setLoading(false);
          console.error("Erreur lors de la récupération des données :", error);
        }
        return data;
      } catch (err) {
        setLoading(false);
        console.error("Erreur dans fetchData :", err);
        return null;
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <>
        <Navbar />
        <Typography variant="h2" sx={{ p: 2 }}>
          Chargement des données en cours ...
        </Typography>
      </>
    );
  }

  const runDate = new Date(data?.run?.runDate);
  const runDateLabel = `${runDate.toLocaleDateString()} - ${runDate.toLocaleTimeString()}`;

  return (
    <>
      <Navbar />
      <Box
        sx={{
          p: 2,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Button sx={{ width: "fit-content" }} onClick={() => navigate("/run")}>
          <ArrowBack />
          Exécutions
        </Button>

        <Typography variant="h1" fontWeight={700}>
          {data?.run?.ville} - {runDateLabel}
        </Typography>

        <Box
          sx={{
            mt: 3,
            p: 2,
            border: "1px solid #ccc",
            borderRadius: 2,
            height: "50%",
            overflow: "auto",
          }}
        >
          <Typography variant="h6">Données du scrapping</Typography>
          {/* Ajoutez ici d'autres détails si disponibles */}
          {data?.data?.map((detail, index) => {
            const dateDepart = detail.job.dateDepart.slice(0, 10);
            const dateRetour = detail.job.dateRetour.slice(0, 10);
            return (
              <Box key={index} sx={{ mt: 2, mb: 4 }}>
                <Typography variant="h5" fontWeight={700}>
                  {`${detail.job.ville} - ${dateDepart} - ${dateRetour}`}
                </Typography>
                <BestOffersTable data={detail.results} expandable />
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

export default OfferPage;
